import { render, staticRenderFns } from "./PlatformFeedbacksPage.vue?vue&type=template&id=3dc6dd26&"
import script from "./PlatformFeedbacksPage.vue?vue&type=script&lang=js&"
export * from "./PlatformFeedbacksPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports